import FilterSidebar from '@components/FilterSidebar/FilterSidebar';
import React, { FunctionComponent, useEffect } from 'react';

import BlockedEmailDomainsFilters from '@components/BlockedEmailDomainsFilters';
import BlockedEmailDomainsTable from '@components/BlockedEmailDomainsTable';
import { getList, reset } from '@stores/blockedEmailDomains';
import css from './BlockedEmailDomainsRoute.module.less';

const BlockedEmailDomainsRoute: FunctionComponent = () => {
  useEffect(() => {
    getList();
    return () => reset();
  }, []);

  return (
    <div className={css.root}>
      <FilterSidebar className={css.sidebar}>
        <BlockedEmailDomainsFilters />
      </FilterSidebar>
      <main className={css.content}>
        <BlockedEmailDomainsTable />
      </main>
    </div>
  );
};

export default BlockedEmailDomainsRoute;
